import type { FC } from 'react'
import type { FormattedAgentActivity, FormattedUserActivity } from '../utils'
import { AgentActivityContent } from './AgentActivityContent'
import { IdleActivityIndicator } from './IdleActivityIndicator'
import { UserActivityContent } from './UserActivityContent'

interface ActivityFeedContentProps {
  readonly activity: FormattedAgentActivity | FormattedUserActivity | null
}

export const ActivityFeedContent: FC<ActivityFeedContentProps> = ({ activity }) => {
  if (!activity || activity.status === 'idle') {
    return <IdleActivityIndicator />
  }

  if (activity.status === 'user' || activity.status === 'system') {
    return <UserActivityContent activity={activity} />
  }

  return <AgentActivityContent activity={activity} />
}
